<template>
  <fieldset class="tab tab-10 none-bg">
    <div class="heading-form a-center">
      <span class="number">10/10</span>
      <p class="c-yellow">สุขภาพทางการเงิน</p>
      <h2 class="heading-h2 c-white">
        โปรดเรียงลำดับการบริหารการเงินที่คุณให้ความสำคัญ
        <span class="br">จากสำคัญมากที่สุดไปน้อยที่สุด</span>
      </h2>
      <p class="desc">(1 = สำคัญที่สุด)</p>
    </div>
    <div class="icw-fieldset-inner">
      <ul class="icw-fields">
        <li class="icw-field icw-field-full">
          <div class="icw-input icw-input-checkbox">
            <!-- <div class="checkbox checkbox-Number" v-for="(val, index) in use_saving_priority" :key="'ordering_money_health_' + index">
                            <input type="checkbox" name="checkbox3[]" :id="'checkbox3__' + index" :value="val" class="css-checkbox" checked="checked" @change="decValue($event)">
                            <label :for="'checkbox3__' + index" class="css-label"><span class="checkNum">{{ index+1 }}</span>{{ getMoneyManageName( val ) }}</label>
                        </div> -->

            <!-- <div :id="'money-health-'+val.key" class="checkbox checkbox-Number" v-for="(val, index) in save_types" :key="'order_money_health_' + index" v-if="!checkHideKey(val.key)">
                            <input type="checkbox" :id="'checkbox3' + index" :value="val.key" :data-index="index" class="css-checkbox" @change="incValue($event)">
                            <label :for="'checkbox3' + index" class="css-label"><span class="checkNum">&nbsp;</span>{{ val.name }}</label>
                        </div> -->

            <div
              :id="'money-health-' + val.key"
              class="checkbox checkbox-Number"
              v-for="(val, index) in save_types"
              :key="'order_money_health_' + index"
            >
              <input
                type="checkbox"
                :id="'checkbox3' + index"
                :value="val.key"
                :data-index="index"
                class="css-checkbox"
                @change="incPriority($event)"
              />
              <label :for="'checkbox3' + index" class="css-label"
                ><span class="checkNum">{{ getIndexPriority(val.key) }}</span
                ><span v-html="val.name"></span
              ></label>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="icw-fieldset-action previous">
      <button
        type="button"
        class="btn btn-previous previous"
        @click="beforePrev()"
      >
        ย้อนกลับ
      </button>
    </div>
    <button
      id="btnNextStep3"
      type="button"
      class="btn btn-next next"
      :class="{ 'btn-disabled': !isPass }"
      @click="beforeNextStep()"
    >
      ถัดไป
    </button>
  </fieldset>
</template>

<script>
import Vue from "vue";

import MyConfig from "@/../me.config.js";

import InputPattern from "vue-pattern-input";

import { my_storage } from "@/helpers/global_helper.js";
import { nextStep, prevStep } from "@/helpers/step_helper.js";

export default {
  name: "QuestionStep2_Q10",
  components: {
    InputPattern
  },
  props: {
    QuestionType: String
  },
  mounted() {
    this.save_types = this.MoneyManageType();
    if (!this.use_saving_priority) {
      this.use_saving_priority = [];
    }
  },
  data() {
    return {
      use_saving_priority:
        sessionStorage.getItem(this.QuestionType) !== ""
          ? JSON.parse(sessionStorage.getItem(this.QuestionType))
          : []
    };
  },
  methods: {
    my_storage,
    nextStep,
    prevStep,
    beforePrev() {
      this.use_saving_priority = [];
      prevStep("tab-10", "tab-09");
    },
    getIndexPriority(key) {
      if (this.use_saving_priority.indexOf(key) > -1) {
        let value = key;
        this.$nextTick(() => {
          $("#money-health-" + value)
            .find("input[type=checkbox]")
            .prop("checked", true);
        });
        return parseInt(this.use_saving_priority.indexOf(key)) + 1;
      }
    },
    incPriority(evt) {
      let v = $(evt.target).val();
      console.log(v);
      if (this.use_saving_priority == null) this.use_saving_priority = [];
      if (this.use_saving_priority.indexOf(v) == -1) {
        this.use_saving_priority.push(v);
      } else {
        this.use_saving_priority.splice(this.use_saving_priority.indexOf(v), 1);
      }
      // this.use_saving_priority.push( $( evt.target ).val() );
    },
    beforeNextStep() {
      let a = $("div[id^=money-health]:visible").length;
      if (this.use_saving_priority) {
        if (
          this.use_saving_priority.length !== 0 &&
          this.use_saving_priority.length >= a
        ) {
          sessionStorage.setItem(
            this.QuestionType,
            JSON.stringify(this._data.use_saving_priority)
          );
          // window.location.href = "http://localhost:8080/step3";
          window.location.href = MyConfig.HealthPath;
        }
      }
      // if (a == 2 && this.use_saving_priority.length >= 2) {
      //   sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data.use_saving_priority))
      //   window.location.href = MyConfig.HealthPath
      // } else if (this.use_saving_priority.length >= 3) {
      //   sessionStorage.setItem(this.QuestionType, JSON.stringify(this._data.use_saving_priority))
      //   window.location.href = MyConfig.HealthPath
      // }
    },
    incValue(evt) {
      let curValue = $(evt.target).val();
      if (this.use_saving_priority == null) this.use_saving_priority = [];
      this.use_saving_priority.push(curValue);
      this.removePrimary(curValue);
    },
    decValue(evt) {
      let curValue = $(evt.target).val();
      let tmp = this.MoneyManageType();
      let data = [];
      let old = this.save_types;

      for (let i = 0; i < tmp.length; i++) {
        if (tmp[i].key == curValue) {
          old.push(tmp[i]);
        }
      }

      for (let i = 0; i < tmp.length; i++) {
        for (let j = 0; j < old.length; j++) {
          if (tmp[i].key == old[j].key) {
            data.push(tmp[i]);
          }
        }
      }

      this.use_saving_priority.splice(
        this.use_saving_priority.indexOf(curValue),
        1
      );
      this.save_types = data;

      $("*[id^=checkbox3__]").each(function() {
        $(this).prop("checked", 1);
      });
    },
    getMoneyManageName(field) {
      let res = this.MoneyManageType();
      let values = res.filter(function(row) {
        if (row.key == field) {
          return row;
        }
      });
      return values[0].name;
    },
    removePrimary(field) {
      let tmp = this.save_types;
      let values = tmp.filter(function(row, i) {
        if (row.key == field) {
          tmp.splice(i, 1);
        }
      });

      this.save_types = tmp;
    },
    checkHideKey(key) {
      let found = false;
      if (key == this.hideFamilyHealth()) {
        found = true;
      }

      if (key == this.hideRetirePlan()) {
        found = true;
      }

      if (key == this.hideLegacyPlan()) {
        found = true;
      }

      return found;
    },
    hideFamilyHealth() {
      let key = "";
      let check = my_storage("MoneyHealth1", "money_health");
      if (check == "-1") key = "stanby";
      return key;
    },
    hideRetirePlan() {
      let key = "";
      let check = my_storage("MoneyHealth6", "money_retire");
      if (check == "-1") key = "save_retire";
      return key;
    },
    hideLegacyPlan() {
      let key = "";
      let check = my_storage("MoneyHealth7", "money_to_child");
      if (check == "-1") key = "legacy";
      return key;
    }
  },
  computed: {
    isPass() {
      let a = $("div[id^=money-health]:visible").length;
      let pass = false;
      if (this.use_saving_priority) {
        if (
          this.use_saving_priority.length !== 0 &&
          this.use_saving_priority.length >= a
        ) {
          pass = true;
        }
      }
      return pass;
      // if (a == 2) {
      //   return !!(this.use_saving_priority != null && this.use_saving_priority.length >= 2)
      // } else {
      //   return !!(this.use_saving_priority != null && this.use_saving_priority.length >= 3)
      // }
    }
  }
};
</script>
